import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { OrganizationStratalotAvancementApiService } from '@_services/api/organization-stratalot-avancement-api.service';
import { AppState } from '@_store/index.reducers';
import { GeneratedOrganizationStratalotAvancementEffects } from './organization-stratalot-avancement-generated.effects';

@Injectable()
export class OrganizationStratalotAvancementEffects extends GeneratedOrganizationStratalotAvancementEffects {
  constructor(
    actions$: Actions,
    organizationStratalotAvancementApiService: OrganizationStratalotAvancementApiService,
    store$: Store<AppState>
  ) {
    super(actions$, organizationStratalotAvancementApiService, store$);
  }
}
